import React, { useCallback, useEffect, useState } from "react";
import { Divider, Layout } from "antd";
import {
  DashBoardIcon,
  LibraryIcon,
  MessagesIcon,
  ScheduleIcon,
  TimeEstimateIcon,
} from "./LayoutIcons";
import { ChevronDoubleIcon, ChevronIcon } from "../svgV2/Chevron";
import CustomAvatar from "../Common/CustomAvatar";
import { PlusIcon } from "../svgV2/PlusIcon";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

import { getProjectPhases } from "../redux/api/scheduleAPI";
import {
  getProjectDetatis,
  getProjectList,
  getProjectPermission,
  getTenantPermission,
} from "../redux/api/projectAPI";
import { getDefaultNavigation } from "../redux/api/settingsAPI";
import { getScreenName } from "../utils/scheduleUtils";
import CustomSearchBox from "../CommonV2/CustomSearchBox";
import { getTenantDetails } from "../redux/api/tenantAPI";
import { changeTenant } from "../redux/slices/tenant.slice";
import { changeWorkspace } from "../redux/api/dashboardAPI";
import { resetToInitialConversation } from "../redux/slices/conversations.slice";
import ClipBoardIcon from "../svgV3/ClipBoardIcon";
import { useGetTenantDetails } from "../redux/ReactQueryHooksV3/useTenantAPI";
import { useQueryClient } from "@tanstack/react-query";
import {
  useGetProjectDetails,
  useGetProjectList,
} from "../redux/ReactQueryHooksV3/useProjectAPI";
import { useGetProjectPhases } from "../redux/ReactQueryHooksV3/useScheduleAPI";
import { MyCalendarIcon } from "../svgV3/MyCalendarIcon";
import { DCFIcon } from "../svgV3/DCFIcon";
import { updateFootprint } from "../redux/slices/footprint.slice";
import { ReportsIcon } from "../svgV3/ReportsIcon";
import { useGetTenantProjects } from "../redux/ReactQueryHooksV3/userTimeEstimatesAPI";
import { updateSchedule } from "../redux/slices/schedule.slice";
// import { getTenantProjects } from "../redux/api/timeEstimatesAPI";

const MenuItemCollapse = ({
  title,
  icon: Icon,
  isSelected = false,
  collapsed,
  submenu = [],
  viewAll = "/library",
  onClick = null,
  redirectionLink = null,
  onContextMenu = null,
  id,
}) => {
  const { filterGoalParameter } = useAppSelector((state) => state.schedule);

  const [isActive, setIsActive] = useState(false);

  const [search, setSearch] = useState("");
  const { projectId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return onClick ? (
    <a
      href={redirectionLink}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <div id={id}>
        <div
          className={`flex group cursor-pointer rounded-lg  justify-between mt-[12px]   py-[5px] ${(isSelected || isActive) && "bg-primary-50"
            } ${collapsed ? "px-[7px]" : "px-5"}`}
          onClick={() => {
            setIsActive(!isActive);
            if (onClick && typeof onClick === "function") {
              onClick();
            }
          }}
        >
          <div className="flex justify-center">
            <Icon
              className={`group-hover:text-primary-600 text-[20px] text-black ${isSelected ? "text-primary-700" : "text-black"
                }`}
            />
            {!collapsed && (
              <span
                className={`out-500-14 group-hover:text-primary-600 ${title === "My Footprint" ? "ml-[8px]" : "ml-[11px]"
                  } ${isSelected ? "text-primary-700" : "text-black"}`}
              >
                {title}
              </span>
            )}
          </div>

          {!collapsed && submenu.length > 0 && (
            <ChevronIcon
              className={`cursor-pointer group-hover:text-primary-600 ${isSelected || isActive ? "text-primary-700" : "text-black"
                }`}
              style={{
                transition: "transform 0.3s ease-in-out 0s",
                transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          )}
        </div>
        {isActive && submenu.length > 0 && !collapsed && (
          <>
            <CustomSearchBox
              placeholder="Search Projects"
              className="mt-3"
              search={search}
              setSearch={setSearch}
              autoFocus={isActive}
            />
            <div className="mt-[12px]  ml-[32px]  border-l border-gray-300">
              <ul className="flex flex-col gap-y-5">
                {submenu
                  .filter((p) =>
                    p.label?.toLowerCase().includes(search.toLowerCase())
                  )
                  .slice(0, 3)
                  .map((menu, index) => (
                    <>
                      <li
                        key={index}
                        className={`pl-4 cursor-pointer hover:text-primary-700 ${menu.link?.includes(projectId)
                          ? "text-primary-700 out-500-14"
                          : "text-black out-300-14"
                          }`}
                      >
                        <Link
                          to={menu.link}
                          onClick={() => {
                            dispatch(
                              updateSchedule({
                                key: "filterGoalParameter",
                                value: {
                                  ...filterGoalParameter,
                                  sprintIds: [],
                                },
                              })
                            );
                          }}
                        >
                          {" "}
                          {menu.label}{" "}
                        </Link>
                      </li>
                    </>
                  ))}
              </ul>
            </div>
            <div className="ml-[48px] cursor-pointer out-500-14 text-primary-600 pt-[8px]">
              <Link to={viewAll}> View all </Link>
            </div>
          </>
        )}
      </div>
    </a>
  ) : (
    <div id={id}>
      <div
        className={`flex group cursor-pointer rounded-lg  justify-between mt-[12px]   py-[5px] ${(isSelected || isActive) && "bg-primary-50"
          } ${collapsed ? "px-[7px]" : "px-5"}`}
        onClick={() => {
          setIsActive(!isActive);
          if (onClick && typeof onClick === "function") {
            onClick();
          }
        }}
      >
        <div className="flex justify-center">
          <Icon
            className={`group-hover:text-primary-600 text-[20px] text-black ${isSelected ? "text-primary-700" : "text-black"
              }`}
          />
          {!collapsed && (
            <span
              className={`out-500-14 group-hover:text-primary-600 ${title === "Time Estimates" ? "ml-[6px]" : "ml-[11px]"
                } ${isSelected ? "text-primary-700" : "text-black"}`}
            >
              {title}
            </span>
          )}
        </div>

        {!collapsed && submenu.length > 0 && (
          <ChevronIcon
            className={`cursor-pointer group-hover:text-primary-600 ${isSelected || isActive ? "text-primary-700" : "text-black"
              }`}
            style={{
              transition: "transform 0.3s ease-in-out 0s",
              transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        )}
      </div>
      {isActive && submenu.length > 0 && !collapsed && (
        <>
          <CustomSearchBox
            placeholder="Search Projects"
            className="mt-3"
            search={search}
            setSearch={setSearch}
            autoFocus={isActive}
          />
          <div className="mt-[12px]  ml-[32px]  border-l border-gray-300">
            <ul className="flex flex-col gap-y-5">
              {submenu
                .filter((p) =>
                  p.label?.toLowerCase().includes(search.toLowerCase())
                )
                .slice(0, 3)
                .map((menu, index) => (
                  // <a
                  //   href="/"
                  //   onClick={(e) => {
                  //     e.preventDefault();
                  //     navigate(menu.link);
                  //   }}
                  //   key={index}
                  // >
                  <li
                    key={index}
                    className={`pl-4 cursor-pointer hover:text-primary-700 ${menu.link?.includes(projectId)
                      ? "text-primary-700 out-500-14"
                      : "text-black out-300-14"
                      }`}
                  >
                    <Link to={menu.link}> {menu.label} </Link>
                  </li>
                  // </a>
                ))}
            </ul>
          </div>
          {/* <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate(viewAll);
            }}
          > */}
          <div
            onClick={() => navigate(viewAll)}
            className="ml-[48px] cursor-pointer out-500-14 text-primary-600 pt-[8px]"
          >
            View all
          </div>
          {/* </a> */}
        </>
      )}
    </div>
  );
};

const WorkSpaceSelect = ({ collapsed }) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { currentTenantId } = useAppSelector((state) => state.tenant);
  const { user } = useAppSelector((state) => state.userDetails);

  const [isActive, setIsActive] = useState(false);
  const { workspaces } = useAppSelector((state) => state.dashboard);

  const hostname = window.location.host;

  const antarcticaTenantId = "3fb2a4e6-f736-4209-aceb-05e77d19b808"; // currently we are restricting some features for antarctica global tenant's users

  const navigate = useNavigate();

  const { data: Data, isLoading, isError } = useGetTenantDetails();
  const tenantDetails = Data?.result;

  const handleSwitchWorkSpace = async (tenantId) => {
    let isCurrentScreenMessages = false;
    if (window.location.pathname == "/messages") {
      isCurrentScreenMessages = true;
    }
    dispatch(changeTenant(tenantId));
    await dispatch(changeWorkspace({ tenantId }));
    dispatch(getTenantDetails({}));
    setTimeout(() => {
      dispatch(resetToInitialConversation({}));
      //location.reload();
      // navigate("/dashboard");

      // if the current screen is messages , redirect the user back to messages screen after switching tenant
      isCurrentScreenMessages
        ? (window.location.href = "/messages")
        : (window.location.href = "/dashboard");
    }, 1500);
  };

  return (
    <div
      onClick={() => setIsActive(!isActive)}
      role="button"
      className={` group cursor-pointer rounded-xl mx-2 justify-between mt-[12px] w-[185px] min-h-[52px] py-[14px] ${!collapsed && "bg-primary-50 border-primary-300 border"
        } `}
    >
      {isActive && !isLoading && !collapsed && (
        <>
          {(hostname !== "localhost:3000" &&
            process.env.REACT_APP_ENV &&
            process.env.REACT_APP_ENV !== "qa" &&
            process.env.REACT_APP_ENV !== "develop" &&
            tenantDetails?.tenantId !== antarcticaTenantId) ||
            +user.roleId === 4 ? (
            <div className="text-primary-600 out-500-12 mt-[8px] flex items-center ml-[18px]">
              <ChevronIcon className="text-primary-600" />{" "}
              <span className="ml-2">Select your Workspace</span>
            </div>
          ) : (
            <div
              role="button"
              onClick={() => navigate("/onboardingV2")}
              className="text-primary-600 out-500-12 mt-[8px] flex items-center ml-[18px]"
            >
              <PlusIcon className="text-primary-600" />{" "}
              <span className="ml-2">Create new</span>
            </div>
          )}

          <div className="mt-[12px] mb-6  ml-[28px]  border-l border-gray-300">
            <ul className="max-h-[20vh] overflow-y-auto">
              {workspaces
                ?.filter((menu) => menu.tenantId !== tenantDetails?.tenantId)
                .map((menu, index) => (
                  <li
                    key={index}
                    role="button"
                    onClick={() => handleSwitchWorkSpace(menu.tenantId)}
                    className="text-black pl-4 cursor-pointer mt-[18px] truncate first:mt-0 hover:text-primary-600 out-300-14"
                  >
                    {menu.tenantName}
                  </li>
                ))}
            </ul>
          </div>
        </>
      )}
      <div
        className={`flex justify-between w-full ${collapsed ? "px-[7px]" : "px-4"
          }`}
      >
        <div className="flex items-center justify-center ">
          <CustomAvatar title={tenantDetails?.tenantName} size={20} />
          {!collapsed && (
            <span className="out-500-14 group-hover:text-primary-600 ml-1 max-h-6 max-w-[88px] truncate  text-primary-600">
              {tenantDetails?.tenantName}
            </span>
          )}
        </div>
        {!collapsed && (
          <div>
            <ChevronIcon
              className={`cursor-pointer group-hover:text-primary-600 ${isActive ? "text-primary-600" : ""
                }`}
              style={{
                transition: "transform 0.3s ease-in-out 0s",
                transform: !isActive ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const { Sider } = Layout;

const SideBar = ({ page }) => {
  const { user } = useAppSelector((state) => state.userDetails);
  const { currentTenantId } = useAppSelector((state) => state.tenant);
  const dispatch = useAppDispatch();
  const [collapsed, setCollaosed] = useState(false);
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { defaultNavigation } = useAppSelector((state) => state.settings);
  const { lastVisitedSchedulePage } = useAppSelector((state) => state.schedule);
  const { data: projectsData, isLoading: isLoadingProject } =
    useGetTenantProjects();

  const [searchParams] = useSearchParams();

  const { data: projectList, isLoading: isLoadingProjectList } =
    useGetProjectList(user.id);
  const {
    data: projectDetails,
    isLoading: isLoadingProjectDetails,
    error: projectDetailsError,
  } = useGetProjectDetails(projectId || searchParams.get("projectId"));
  const {
    data: projectPhases,
    isLoading: isLoadingProjectPhases,
    error: projectPhasesError,
  } = useGetProjectPhases(projectId || searchParams.get("projectId"));

  useEffect(() => {
    dispatch(getDefaultNavigation({ userId: user.id }));
    dispatch(
      getTenantPermission({
        userId: user.id,
      })
    );
  }, [user.id]);

  useEffect(() => {
    if (projectId) {
      dispatch(
        getProjectPermission({
          projectId,
          userId: user.id,
        })
      );
    }
  }, [projectId, user.id]);

  const handleToggle = () => {
    // case 1 if isSideBarOpen === true then mouseEventShoun't work and handleToggle should set isSideOPen to false
    // case 2 if isSideBarOpen === false the mouseEvent should work and handleToggle should set isSideBarOpen to true
    if (isSideBarOpen) {
      setIsSideBarOpen(false);
      setCollaosed(true);
    } else {
      setIsSideBarOpen(true);
      setCollaosed(false);
    }
  };

  const getLayoutWidth = () => {
    if (isSideBarOpen) {
      return 200;
    } else {
      return 50;
    }
  };

  const effectiveCollapsed = !isSideBarOpen
    ? isHovering
      ? false
      : true
    : collapsed;

  const effectiveWidth = !isSideBarOpen && isHovering ? 200 : getLayoutWidth();

  let timeEstimatesSubmenu = [];
  const projects = projectsData?.projects;

  if (projects?.length > 0) {
    timeEstimatesSubmenu = [
      ...projects.map((project) => ({
        label: project.title,
        link: `/time-estimates/${project.id}`,
      })),
    ];
  }

  let librarySubmenu = [
    {
      label: "My Library",
      link: `/library/my-library/lib-${user.myLibraryId}`,
    },
  ];
  if (projectList?.length > 0) {
    librarySubmenu = [
      {
        label: "My Library",
        link: `/library/my-library/lib-${user.myLibraryId}`,
      },
      ...projectList.map((project) => ({
        label: project.title,
        link: `/library/${project.id}`,
      })),
    ];
  }
  if (+user.roleId === 4) {
    if (projectList) {
      if (projectList.length <= 0) {
        librarySubmenu = [];
      } else {
        librarySubmenu = [
          ...projectList.map((project) => ({
            label: project.title,
            link: `/library/${project.id}`,
          })),
        ];
      }
    }
  }

  const getScheduleSubmenu = useCallback(() => {
    let scheduleSubmenu = [];
    if (projectList?.length > 0) {
      let screenName = "roadmap";
      if (defaultNavigation.isEnabled) {
        screenName = getScreenName(defaultNavigation.screenId);
      }
      scheduleSubmenu = projectList.map((project) => ({
        label: project.title,
        link:
          +lastVisitedSchedulePage?.projectId === +project.id
            ? lastVisitedSchedulePage?.redirectUrl
            : project.currentactivesprint
              ? `/schedule/${project.id}/${screenName}/${screenName == "sprints" ? project.currentactivesprint : ""
              }`
              : `/schedule/${project.id}/${screenName}`,
      }));
    }
    return scheduleSubmenu;
  }, [projectList, defaultNavigation]);

  return (
    <>
      {/* {collapsed && <div className="h-screen w-[50px] " />} */}
      {!isSideBarOpen && <div className="h-screen w-[50px] " />}

      <Sider
        trigger={null}
        collapsible
        collapsed={!isSideBarOpen ? true : collapsed}
        collapsedWidth={!isSideBarOpen ? 50 : collapsed ? 50 : 200}
        width={effectiveWidth}
        style={{
          position: !isSideBarOpen ? "fixed" : "relative",
          height: "100%",
          zIndex: 2,
          transition: "width 0.3s ease-in-out",
          overflow: "hidden",
        }}
      >
        <div
          className="h-full bg-white border-r border-gray-200"
          onMouseEnter={() => {
            if (!isSideBarOpen) {
              setIsHovering(true);
            }
          }}
          onMouseLeave={() => {
            if (!isSideBarOpen) {
              setIsHovering(false);
            }
          }}
          style={{
            width: effectiveWidth,
            transition: "width 0.3s ease-in-out",
            overflow: "hidden",
          }}
        >
          <div className="flex flex-col justify-between h-full">
            <div>
              <div
                className={`flex items-center justify-between ${collapsed ? "px-[13px]" : "px-6"
                  } pt-[18px]`}
              >
                <img
                  className=""
                  alt="logo"
                  src={
                    collapsed
                      ? "/images/v2/layout/w.svg"
                      : "/images/v2/layout/Logo.svg"
                  }
                />

                <button
                  className={`${effectiveCollapsed ? "hidden" : "block"}`}
                  onClick={() => handleToggle()}
                >
                  <ChevronDoubleIcon
                    rotate={90}
                    style={{
                      transition: "transform 0.3s ease-in-out 0s",
                      transform: !isSideBarOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </button>
              </div>
              <div className="px-2">
                <MenuItemCollapse
                  title={"Dashboard"}
                  icon={DashBoardIcon}
                  collapsed={effectiveCollapsed}
                  isSelected={page === "dashboard"}
                  redirectionLink={`/dashboard/${projectId ? projectId : ""}`}
                  onContextMenu={() =>
                    window.open(
                      `/dashboard/${projectId ? projectId : ""}`,
                      "_blank"
                    )
                  }
                  onClick={() => {
                    navigate(`/dashboard/${projectId ? projectId : ""}`);
                  }}
                  id="dashboard-tour-dashboard"
                />
                {user.roleId !== 4 && !user.isGuestDeactivated && (
                  <MenuItemCollapse
                    title={"Messages"}
                    icon={MessagesIcon}
                    isSelected={page === "messages"}
                    redirectionLink={"/messages"}
                    collapsed={effectiveCollapsed}
                    onContextMenu={() => window.open("/messages", "_blank")}
                    onClick={() => navigate("/messages")}
                    id="dashboard-tour-messages"
                  />
                )}
                {user.roleId !== 4 && !user.isGuestDeactivated && (
                  <MenuItemCollapse
                    title={"Projects"}
                    icon={ScheduleIcon}
                    collapsed={effectiveCollapsed}
                    isSelected={page === "schedule"}
                    submenu={getScheduleSubmenu()}
                    viewAll="/dashboard?showAllProjects=1"
                    id="dashboard-tour-schedule"
                  />
                )}

                <MenuItemCollapse
                  title={"Library"}
                  icon={LibraryIcon}
                  isSelected={page === "library"}
                  collapsed={effectiveCollapsed}
                  submenu={librarySubmenu}
                  viewAll="/library"
                  id="dashboard-tour-library"
                />

                {/* <MenuItemCollapse
                  title={"Time Estimates"}
                  icon={TimeEstimateIcon}
                  isSelected={page === "time-estimates"}
                  collapsed={collapsed}
                  submenu={timeEstimatesSubmenu}
                  viewAll="/time-estimates"
                  id="dashboard-tour-time-estimates"
                /> */}

                <MenuItemCollapse
                  title={"Reports"}
                  icon={ReportsIcon}
                  isSelected={page === "reportsV3" || page === "time-estimates"}
                  collapsed={effectiveCollapsed}
                  onContextMenu={() => window.open("/my-calendar", "_blank")}
                  onClick={() => navigate("/reports")}
                  id="dashboard-tour-my-calendar"
                />

                <Divider className="mt-2 mb-0" />

                <MenuItemCollapse
                  title={"My Board"}
                  icon={ClipBoardIcon}
                  isSelected={page === "my-board"}
                  redirectionLink={"/my-board"}
                  collapsed={effectiveCollapsed}
                  onContextMenu={() => window.open("/my-board", "_blank")}
                  onClick={() => navigate("/my-board")}
                  id="dashboard-tour-my-board"
                />

                <MenuItemCollapse
                  title={"My Calendar"}
                  icon={MyCalendarIcon}
                  isSelected={page === "my-calendar"}
                  redirectionLink={"/my-board"}
                  collapsed={effectiveCollapsed}
                  onContextMenu={() => window.open("/my-calendar", "_blank")}
                  onClick={() => navigate("/my-calendar")}
                  id="dashboard-tour-my-calendar"
                />

                <MenuItemCollapse
                  title={"My Footprint"}
                  icon={DCFIcon}
                  isSelected={page === "my-footprint"}
                  redirectionLink={"/my-footprint"}
                  collapsed={effectiveCollapsed}
                  onContextMenu={() => window.open("/my-footprint", "_blank")}
                  onClick={() => {
                    dispatch(
                      updateFootprint({ key: "welcomeModal", value: true })
                    );
                    navigate("/my-footprint");
                  }}
                  id="dashboard-tour-my-footprint"
                />
              </div>
            </div>
            <div className="mb-2 " id="dashboard-tour-workspace">
              <WorkSpaceSelect collapsed={effectiveCollapsed} />
            </div>
          </div>
        </div>
      </Sider>
    </>
  );
};

export default SideBar;
